module.exports = __webpack_public_path__ + "img/people16.ed3e439f.png";